export interface Glossary {
  code: string;
  labelHtml: string;
  text: string;
}
